import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const PdfDropzone = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  ${font('sm', 'regular')}
  outline: var(--purple-500, #4e56ea);
  border: 1px dashed var(--purple-500, #4e56ea);
  background-color: var(--purple-050, #ecf3ff);
  color: var(--neutral-900, #222b33);
  padding: 1.25rem;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;

  .action-text {
    color: var(--purple-500, #4e56ea);
  }

  &.drag-over {
    border-style: solid;
  }

  input {
    position: absolute;
    inset: 0;
    cursor: pointer;
    opacity: 0;
    width: 0;
    height: 0;
  }
`

export const PdfSelectedFile = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--neutral-100, #e5e9ed);
  background-color: var(--white, #ffffff);
`

export const PdfSelectedFileName = styled.span`
  ${font('sm', 'bold')}
  color: var(--black, #222b33);
  flex-grow: 1;
  word-break: break-word;
`

export const PdfSelectedFileSize = styled.span`
  ${font('sm', 'regular')}
  flex-shrink: 0;
  color: var(--neutral-500, #607890);
`
